module.exports = __webpack_public_path__ + "static/raspberry-d18fb1c7b3ae6febdbf4e7c92d6dcecd.svg";